import Cookies from "js-cookie";
import { useMutation } from "react-query";
import { serverBaseUrl } from "../config/envs";

// Updated add function for file upload using FormData
const add = async (token = null, postData) => {
  const formData = new FormData();
  formData.append("file", postData.file); // postData should contain the file in the 'file' field

  const headers = {};
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const response = await fetch(`${serverBaseUrl}/upload-template-document`, {
    method: "POST",
    headers,
    body: formData,
  });

  const data = await response.json();
  console.log("Status Code:", response);

  if (response.status === 400) {
    console.log(data, "data400");
    return data;
  }
  if (response.status === 500) {
    console.log(data, "data500");
    return data;
  }

  if (!response.ok) {
    throw new Error(data);
  }
  return data;
};

// useUploadTemplateDocument hook
export const useUploadTemplateDocument = () => {
  const token = Cookies.get("token");
  return useMutation(["upload-template-document", token], (postData) =>
    add(token, postData)
  );
};
